import { Component, OnInit, inject, Output, EventEmitter, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { AppSettings } from '@services/settings/app-settings.service';
import { ListCardComponent } from 'app/core/components/list-card/list-card.component';
import { MobileFooterComponent } from 'app/core/components/mobile-footer/mobile-footer.component';
import { BottomSheetComponent } from 'app/core/components/bottom-sheet/bottom-sheet.component';

@Component({
    selector: 'app-users-list',
    standalone: true,
    imports: [CommonModule, NgSelectModule, FormsModule, ListCardComponent, MobileFooterComponent, BottomSheetComponent],
    templateUrl: './users-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './users-list.component.css'
})
export class UsersListComponent implements OnInit {

    users: any[] = [];
    filteredUsers: any[] = [];
    usersSelected: any[] = [];
    searchText = '';
    mobileFiltersOpen = false;

    isLoading = true;
    rows = Array.from({ length: 5 }, (_, i) => i + 1);
    public appSettings = inject(AppSettings);

    public order: boolean = true;
    public orderColName: string = 'displayName';
    selectedId = signal<any>(null);
    badgeValue = signal<string>('true');
    fieldBadge = signal<string>('isActive');

    private userService = inject(UserService);

    @Output() selectEvent = new EventEmitter<any>();

    constructor() { }

    ngOnInit(): void {
        this.loadUsers();
    }

    loadUsers() {
        this.isLoading = true;
        this.userService.get().subscribe({
            next: (res) => {
                this.users = res;
                this.changeSelect();
                this.isLoading = false;
            },
            error: (err) => {
                console.error(err);
                this.isLoading = false;
            }
        });
    }

    changeSelect() {
        let list = [...this.users];

        if (this.usersSelected && this.usersSelected.length > 0) {
            list = list.filter(u => this.usersSelected.includes(u.uuid));
        }
        if (this.fieldBadge() !== '' && this.badgeValue() !== '') {
            list = list.filter(u => String(u[this.fieldBadge()]) === this.badgeValue());
        }
        const term = (this.searchText || '').trim().toLowerCase();
        if (term) {
            list = list.filter((u) =>
                [u.displayName, u.mail, this.roleSummary(u)]
                    .filter(Boolean)
                    .some((v) => String(v).toLowerCase().includes(term))
            );
        }

        this.filteredUsers = list;
    }

    toggleBadge(field: string, value: string) {
        if (this.fieldBadge() === field && this.badgeValue() === value) {
            this.badgeValue.set('');
            this.fieldBadge.set('');
        } else {
            this.badgeValue.set(value);
            this.fieldBadge.set(field);
        }
        this.changeSelect();
    }


    selectUser(user: any) {
        this.selectedId.set(user.uuid);
        this.selectEvent.emit(user);
    }

    roleSummary(user: any): string {
        const roles = Array.isArray(user?.roles) ? user.roles : [];
        if (roles.length > 1) {
            const active = user?.role?.displayName || user?.role?.description || user?.role?.name || '';
            return `${active || 'Multi-rol'} (+${roles.length - 1})`;
        }
        if (roles.length === 1) {
            return roles[0].displayName || roles[0].description || roles[0].name || '';
        }
        return user?.role?.displayName || user?.role?.description || user?.role?.name || '';
    }
}
